import { createContext } from "react";

export type RouteParams = {
  vestiging: string;
  voorstel?: string;
  adviesdossier: string;
};

const defaultMatch: RouteParams = {
  vestiging: "",
  voorstel: "",
  adviesdossier: ""
};

const ParamRouteContext = createContext(defaultMatch);

export default ParamRouteContext;
